enum EnumMobileRoles {
	None = 0,
	RegionalManager = 1,
	Engineer = 2,
	Сollector = 3
}
export default EnumMobileRoles



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Enums/EnumMobileRoles.ts